//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/GeometricUtilities.js";
import "../no/TaggedObject.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/SelectFace.js";
import "../no/Expression.js";
import "../no/Expression.js";
import "../no/SelectObject.js";
let d=[[[0,"CanReverseDirection",1,0],[1,"Continuity",0,"GeometricUtilities.Continuity",0],[0,"CurveDirectionOption",1,0],[0,"DirectionAtPoint",1,"Direction",0],[0,"FaceDirectionOption",1,0],[1,"LocationOnSection",0,"GeometricUtilities.OnPathDimensionBuilder",0],[1,"PerpendicularFace",0,"SelectFace",0],[1,"SectionAngle",0,"Expression",0],[1,"UPercentage",0,"Expression",0],[1,"VPercentage",0,"Expression",0]],[[[],"UpdateOnDirectionAtPointReversal",{},0,0],[["uPercent","vPercent"],"EditUVPercentage",{},2,0],[[],"UpdateBasedOnLocationOnSection",{},0,0],[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.GeometricUtilities.BridgeCurveConnectivity = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.GeometricUtilities.BridgeCurveConnectivity";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.GeometricUtilities.BridgeCurveConnectivity.CurveDirectionOptions = Object.freeze({
    "Tangent" : "Tangent", "Perpendicular" : "Perpendicular"});

SPLM.GeometricUtilities.BridgeCurveConnectivity.FaceDirectionOptions = Object.freeze({
    "Sectional" : "Sectional", "IsoU" : "IsoU", "IsoV" : "IsoV"});

export default SPLM;